<template>
  <main :class="b()">
    <div :class="b('content')">
      <h1 :class="b('title')">
        {{ $t('app.error.title') }}
      </h1>

      <div :class="b('description')" v-html="$t('app.error.description')" />
    </div>
    <ga-button
      theme="flat"
      :text="$t('app.error.refresh')"
      @click="onRefreshClick"
    />
  </main>
</template>

<script src="./scripts.js" />

<style lang="scss" module src="./styles.scss" />
